import { forwardRef, type Ref, type SVGProps } from "react";
const IconEditFormFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M23.73 7.14A2 2 0 0 0 23 7H4a2 2 0 0 0-2 2v19a2 2 0 0 0 2 2h19a2 2 0 0 0 2-2V9a2 2 0 0 0-.14-.73ZM23 28H4V9h19Z" />
    <path d="M22.36 5.77 11.69 16.44a.4.4 0 0 0-.1.12l-.05.11a.4.4 0 0 0 0 .16L11 20.22a.69.69 0 0 0 .19.58.68.68 0 0 0 .49.2h.09l3.39-.48a.6.6 0 0 0 .28-.11.3.3 0 0 0 .11-.09L26.23 9.65Z" />
    <path d="M29.8 5.11 26.89 2.2a.67.67 0 0 0-.48-.2.7.7 0 0 0-.49.2l-2.15 2.16 3.88 3.87 2.15-2.15a.68.68 0 0 0 0-.97" />
  </svg>
);
const ForwardRef = forwardRef(IconEditFormFilledSVG);
ForwardRef.displayName = "IconEditFormFilled";
export { ForwardRef as IconEditFormFilled };
